import { Endpoint, UpdateBankCustomerResponse, UpdateKycInfoRequest, VerifyAuthCodeResponse } from '../types'
import {
  AcceptApplicationRequest,
  AddMinorToHouseholdRequest,
  CreateApplicationRequest,
  DigiLaGetMinorUserInfoRequest,
  DigiLaGetMinorUserInfoResponse,
  DigiLaUserInfoResponse,
  DigiLaVerifyAuthCodeRequest,
} from './types'

export const ENDPOINT_DIGILA_VERIFY_AUTH_CODE: Endpoint<VerifyAuthCodeResponse, DigiLaVerifyAuthCodeRequest> = {
  path: '/verify-auth-code',
  method: 'post',
}

export const ENDPOINT_DIGILA_GET_USER_INFO: Endpoint<DigiLaUserInfoResponse> = {
  path: '/user-info',
  method: 'get',
}

export const ENDPOINT_DIGILA_UPDATE_GUARDIAN_KYC_INFO: Endpoint<UpdateBankCustomerResponse, UpdateKycInfoRequest> = {
  path: '/update-guardian-kyc-info',
  method: 'put',
}

export const ENDPOINT_DIGILA_GET_MINOR_USER_INFO: Endpoint<
  DigiLaGetMinorUserInfoResponse,
  DigiLaGetMinorUserInfoRequest
> = {
  path: '/get-minor-user-info',
  method: 'put',
}

export const ENDPOINT_DIGILA_ADD_MINOR_TO_HOUSEHOLD: Endpoint<void, AddMinorToHouseholdRequest> = {
  path: '/add-minor-to-household',
  method: 'put',
}

export const ENDPOINT_DIGILA_UPDATE_MINOR_KYC_INFO: Endpoint<UpdateBankCustomerResponse, UpdateKycInfoRequest> = {
  path: '/update-minor-kyc-info',
  method: 'put',
}

export const ENDPOINT_DIGILA_CREATE_APPLICATION: Endpoint<void, CreateApplicationRequest> = {
  path: '/application',
  method: 'post',
}

export const ENDPOINT_DIGILA_REJECT_APPLICATION: Endpoint = {
  path: '/application/reject',
  method: 'put',
}

export const ENDPOINT_DIGILA_ACCEPT_APPLICATION: Endpoint<void, AcceptApplicationRequest> = {
  path: '/application/accept',
  method: 'put',
}
